import '../lib/js-cookie';

export const cookieModule = {
  cookieBanner: document.querySelector('.js-cookiebanner'),
  ex: 365,

  init() {
    if (
      this.cookieBanner &&
      !Cookies.get('cookiesIsAccepted') &&
      !Cookies.get('cookiesIsDeclined')
    ) {
      this.cookieBanner.classList.add('show');

      var cookieBannerAcceptBtn = document.querySelector(
        '.js-cookiebanner-accept-btn',
      );
      cookieBannerAcceptBtn.addEventListener('click', this.onAcceptCookieClick);

      var cookieBannerDeclineBtn = document.querySelector(
        '.js-cookiebanner-decline-btn',
      );
      cookieBannerDeclineBtn.addEventListener(
        'click',
        this.onDeclineCookieClick,
      );
    }

    const cookieconsentChangeBtns = document.querySelectorAll(
      '.js-cookie-consent-change',
    );
    if (cookieconsentChangeBtns.length) {
      cookieconsentChangeBtns.forEach(btn => {
        btn.addEventListener('click', this.handleCookieConsentChange);
      });
    }
  },

  handleCookieConsentChange(e) {
    e.preventDefault();
    cookieModule.cookieBanner.classList.add('show');
  },

  onAcceptCookieClick(e) {
    e.preventDefault();
    Cookies.set('cookiesIsAccepted', 'true', {
      expires: cookieModule.ex,
      path: '/',
    });
    Cookies.remove('cookiesIsDeclined');
    $vizzit.cookie.set();
    cookieModule.cookieBanner.classList.remove('show');
  },

  onDeclineCookieClick(e) {
    e.preventDefault();
    Cookies.set('cookiesIsDeclined', 'true', {
      expires: cookieModule.ex,
      path: '/',
    });
    Cookies.remove('cookiesIsAccepted');
    Cookies.remove('___vizzit');
    cookieModule.cookieBanner.classList.remove('show');
  },
};
